import { useRef } from "react";
import { useInputEditor } from "src/components/useInputEditor";
import { useTinyMce } from "src/components/useTinyMce";
import styles from "./styles.module.scss";
import cx from "classnames";

type RenderType = "inputPlaceholder" | "buttonText";
interface PasswordProtection {
  headerText: string;
  descriptionText: string;
  buttonText: string;
  inputPlaceholderText: string;
}

// parent renders (header, description, button, inputPlaceholder) 
export const usePasswordProtection = ({ headerText, descriptionText, buttonText, inputPlaceholderText}: PasswordProtection) => {
  const header = usePasswordProtectionTinyMce({value: headerText}); // tinymce
  const description = usePasswordProtectionTinyMce({value: descriptionText}); // tinymce
  const button = usePasswordProtectionInput({ // inputEditor
    value: buttonText,
    viewerType: "buttonText",
  });
  const inputPlaceholder = usePasswordProtectionInput({ // inputEditor
    value: inputPlaceholderText,
    viewerType: "inputPlaceholder",
  });

  return {
    header,
    description,
    button,
    inputPlaceholder,
  };
};

// inputEditor Hook
export function usePasswordProtectionInput({value, viewerType}: {value: string, viewerType: RenderType}) {
   const values = useRef(value)
   return useInputEditor(values.current, viewerType);
}

// tinyMce Hook
export function usePasswordProtectionTinyMce({value}: {value: string}) {
   const values = useRef(value)
   return useTinyMce(values.current);
}

// Viewer
export const PasswordProtectionViewer = ({ HeaderText, Description ,ButtonText, InputPlaceHolderText, buttonColor, buttonTextColor }) => (
  <div className={styles.viewerContainer}>
    <div className={styles.innerContainer}>
      <div className={styles.header}>
        <div className={styles.restrictEvents}>
          <HeaderText/>
        </div>    
      </div>
      <div className={styles.subContainer}>
        <div className={styles.description}>
          <Description  />
        </div>
        <InputPlaceHolderText />
      </div>
    </div>
    <ButtonText inlineStyles={{ backgroundColor: buttonColor, color: buttonTextColor }} />
 </div>
);

// Editor
export const PasswordProtectionEditor = ({  HeaderText, Description , ButtonText, InputPlaceHolderText }) => (
  <div className={styles.editorContainer}>
    <div className={styles.header}>
       <h5 className={styles.title}>Password Protect Customization</h5>
       <p className={styles.subText}>They Shall Not Pass! Without the password that is. Customise your password requirement text here.</p>
    </div>
    <div className={styles.inputContainer}>
      <p className={styles.label}>Header Text</p>
      <HeaderText 
        classnames={cx(styles.tinyMce, styles.headerContainer)} 
        plugins = 'code noneditable, variable, widget,  autolink, link, textcolor, lists, paste'
        toolbar = 'bold italic | alignleft aligncenter alignright | numlist bullist | fontselect | fontsizeselect | forecolor backcolor | link'
        quickToolbar={true}
        transparentBackground={true}
      />
    </div>
    <div className={styles.inputContainer}>
      <p className={styles.label}>Description Text</p>
      <Description
         classnames={cx(styles.tinyMce, styles.descriptionContainer)}
         plugins = 'code noneditable, variable, widget,  autolink, link, textcolor, lists, paste'
        toolbar = 'bold italic | alignleft aligncenter alignright | numlist bullist | fontselect | fontsizeselect | forecolor backcolor | link'
        quickToolbar={true}
        transparentBackground={true}
      />
    </div>
    <div className={styles.inputGroup}>
      <div className={styles.inputContainer}>
         <p className={styles.label}>Button Text</p>
         <ButtonText maxLength={20} />
      </div>
       <div className={styles.inputContainer}>
         <p className={styles.label}>Placeholder Text</p>
         <InputPlaceHolderText maxLength={20} />
      </div>
    </div>
 </div>
);
